<template>
  <footer class="foot" :style="{'background-img':bg}">
    <div class="foot-content">
        <div class="list-ui">
            <article v-for="(item,index) in nav" :key="index">
                <a :href="item.link" target="_blank">{{item.title}}</a>
            </article>
        </div>

        <div class="tag-ui">
            <p v-for="(item,index) in tag" :key="index">
                <a :href="item.link" v-if="item.link">{{item.title}}</a>
                <span v-else>{{item.title}}</span>
            </p>
        </div>
    </div>
  </footer>
</template>
<script>
import {http} from '@/utils/http'

export default {
    name: 'popFooter',
    data(){
        return {
            bg:'',
            nav:[],
            tag:[]
        }
    },
    async created(){
        const res = await http.get('//cms.haiziwang.com/publish/976/pop-footer.json')
        this.bg = res.bg;
        this.nav = res.nav;
        this.tag = res.tag;
        // this.setFooterInfo(res)
    },
}
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  height: 120px;
  background: #676f79;
  // background: url('~@assets/images/footer_bg@2x.png') no-repeat;
  // background-size: cover;
  display: flex;
  justify-content: center;
  .foot-content {
    display: flex;
    // @include Width;
    flex-direction: column;

    .list-ui
    {
      display: flex;
      justify-content: center;
      padding-top: 32px;

        article {
          padding: 0 28px;
          position: relative;
          &:after {
            content: "";
            position: absolute;
            right: 0;
            height: 11px;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            background: #D0D9ED;
          }
          &:last-child:after {
            width: 0;
          }
          a {
            font-size: 15px;
            color: #D0D9ED;
          }
        }
    }
    .tag-ui {
      display: flex;
      // @include Width;
      margin-top: 16px;
      justify-content: center;

      p {
        position: relative;
        font-size: 14px;
        color: #8A93A7;
        padding: 0 10px;
        padding-right: 14px;
        &:after {
          content: "/";
          color: #8A93A7;
          position: absolute;
          right: -5px;
          height: 18px;
          top: 50%;
          font-size: 11px;
          transform: translateY(-50%);
          width: 10px;
        }
        &:last-child:after {
          content:"";
        }

        a{
          color: #8A93A7;
        }
      }
    }
  }
}
</style>


